/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'

type Props = {
    to: string
    title: string
}

const PageMenuLink: FC<Props> = ({to, title}) => {
    return (
    <div className='menu-item p-0 m-0'>
        <Link 
        to={to} 
        className='menu-link'
        >
        <span className='menu-bullet'>
            <span className='bullet bullet-dot bg-gray-300i h-6px w-6px'></span>
        </span>
        <span className='menu-title'>{title}</span>
        </Link>                    
    </div>
    )
}

export { PageMenuLink }